import { InputText as PInputText, InputTextProps as PInputTextProps } from 'primereact/inputtext';
import { Password, PasswordProps } from 'primereact/password';
import React from 'react';
import { InputTextIcon } from './input-text-icon';

type InputTextProps = PInputTextProps &
  PasswordProps & {
    name: string;
    placeholder?: string;
    iconLeft?: string;
    iconRight?: string;
    password?: boolean;
    error?: string | boolean;
    noErrorPadding?: boolean;
  };

export const InputText = ({ iconLeft, iconRight, password, error, noErrorPadding, ...rest }: InputTextProps) => {
  return (
    <>
      <div className="p-inputgroup">
        {iconLeft && <InputTextIcon icon={iconLeft} />}
        {password ? (
          <Password className={error ? 'p-invalid' : '' + 'block flex p-fluid'} {...rest} />
        ) : (
          <PInputText className={error ? 'p-invalid' : '' + 'block'} {...rest} />
        )}
        {iconRight && <InputTextIcon icon={iconRight} />}
      </div>
      <div className={noErrorPadding ? '' : 'pb-3'}>
        {error && <small className="p-error mt-1 block">{error}</small>}
      </div>
    </>
  );
};
